import actionTypes from 'constants/actionTypes'

type ConfirmableAction = Record<string, unknown>


export const confirmModal = (idx: number) => {
  return {
    type: actionTypes.CONFIRM.CONFIRM,
    payload: { idx }
  }
}

export const cancelModal = (idx: number) => {
  return {
    type: actionTypes.CONFIRM.CANCEL,
    payload: { idx }
  }
}

export const initiateConfirmation = ({ message, action }: { message: string; action: ConfirmableAction }) => {
  return {
    type: actionTypes.CONFIRM.INITIATE,
    payload: { message, action }
  }
}
